import { useCookies } from 'react-cookie';
import {useEffect} from 'react';

export function UserNav(props) {

  const [cookies, setCookie] = useCookies();
  const hostname = window.location.host;


  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    
    const utm_campaign = params.get("utm_campaign");
    const utm_source = params.get("utm_source");
    const utm_medium = params.get("utm_medium");
    const utm_term = params.get("utm_term");

    //utm_data cookie
    if (utm_campaign && cookies.utm_data?.utm_campaign !== utm_campaign) {
      setCookie(`utm_data`, {
        "utm_campaign": utm_campaign,
        "utm_source": utm_source,
        "utm_medium": utm_medium,
        "utm_term": utm_term,
        "Referrer":document.referrer
      }, {
        maxAge: 7889400
      });
    } else if(!cookies.utm_data){
      setCookie(`utm_data`, {
        "Referrer":document.referrer|| "N/A"
      }, {
        maxAge: 7889400
      });
    }
  });

return (
  <ul className={`user-nav`}>
    <li class="searchform">
      <form className="search-all" action={`//${hostname}/search/main_menu_search`} method="POST">
        <input type="text" placeholder="Search GrapeCity" name="term" id="nav-search" />
        <input type="submit" value="Search" />
      </form>
    </li>
    <li class="search">
      <i class="fa fa-search" aria-hidden="true"><span>Search</span></i>
    </li>
    <li className={`cart`}>
      <a href={`//${hostname}/cart`}>
        <i class="fa fa-shopping-cart" aria-hidden="true"><span>Cart</span></i>
        {cookies.user_nav?.cart_items &&
          <div className={`cart-items-count`}>
            {cookies.user_nav.cart_items}
          </div>
        }
      </a>
    </li>
    {(() => {
      if (cookies.user_nav?.avatar) {
        return (
          <li class={`user rnav-inner-drop-trigger user`}>
            <a href={`//${hostname}/my-account`}>
              <img src={cookies.user_nav.avatar} alt="" className={`gravatar`} ></img>
            </a>
            <ul class="rnav-inner-drop user">
              <li><a href={`//${hostname}/my-account`}>My Account</a></li>
              <li><a href={`//${hostname}/my-account/my-profile`}>My Profile</a></li>
              <li><a href={`//${hostname}/my-account/my-licenses`}>My Licenses</a></li>
              <li><a href={`//${hostname}/my-account/my-quotes`}>My Quotes</a></li>
              <li><a href={`//${hostname}/logout`}>Logout</a></li>
            </ul>
          </li>
        )

      } else {
        return (
          <li className={`user`}>
            <a href={`//${hostname}/my-account`}>
              <i class="fa fa-user-circle-o" aria-hidden="true"><span>My Account</span></i>
            </a>
          </li>
        )
      }

    })()}

  </ul>
);
}

export default UserNav;
